// extracted by mini-css-extract-plugin
export default {"page":"sellproductpage_page__A6hrN","navBar":"sellproductpage_navBar__npAdf"};